import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Tabs, Tab, ProgressBar } from 'react-bootstrap';
import './connections.less';
import BoxSwitch from './BoxSwitch';
import DropboxSwitch from './DropboxSwitch';
import GoogleDriveSwitch from "./GoogleDriveSwitch";
import IManageSwitch from "./IManageSwitch";
import NetDocumentsSwitch from './NetDocumentsSwitch';
import NetDocumentsDocketLinkPanel from "./NetDocumentsDocketLinkPanel";
import OneDriveSwitch from './OneDriveSwitch';
import CalendarFeedSwitch from './CalendarFeedSwitch';
import CalendarFeedConfig from "./CalendarFeedConfig";
import FileSyncSettings from "./FileSyncSettings";
import RocketMatterSwitch from './RocketMatterSwitch';
import SharepointSwitch from "./SharepointSwitch";
import SharepointConnectionSettings from "./SharepointConnectionSettings";
import FileSyncUploadDestinationSettings from "./FileSyncUploadDestinationSettings";
import Notification from '../../components/common/Notification/Notification';
import { getConnections } from '../../redux/actions/integrationsConnectionActions';


// Icons --------------------------------------------------------------
import box from './icons/box.png';
import dropbox from './icons/dropbox.png';
import gdrive from './icons/gdrive.png';
import onedrive from './icons/onedrive.png';
import onedrivebiz from './icons/onedrivebiz.png';
import rocketmatter from './icons/rocketmatter.png';
import sharepointonline from './icons/sharepointonline.png';
// --------------------------------------------------------------------

import FilenameTemplate from './FilenameTemplate/FilenameTemplate';
import InstructionsPanel from './InstructionsPanel';
import PricingAgreement from './FilenameTemplate/PricingAgreement';
import NetDocumentsCabinetsConfig from './NetDocumentsCabinetsConfig';
import { drupalPermsInclude } from '../../util/globalUtils';
import ClioSwitch from "./ClioSwitch";
import ClioConnectionSettings from "./ClioConnectionSettings";

const icons = {
  box,
  dropbox,
  gdrive,
  onedrive,
  onedrivebiz,
  sharepointonline,
};

class ConnectionsLayout extends Component {
  componentDidMount() {
    this.props.dispatch(getConnections());
  }

  render() {
    const { kloudless } = this.props;
    const { errorMessage, isLoading, results, agreedToPricing } = kloudless;
    const connections = _.get(kloudless, 'results', []);

    const svcProps = (svcName) => {
      const connectionDetails = _.find(results, { service: svcName }) || {};
      const key = `integration-connection-switch-${svcName}`;

      return {
        key,
        dispatch: this.props.dispatch,
        imgSrc: icons[svcName],
        connectionId: connectionDetails.connectionId || null,
        svcName,
        agreedToPricing,
      };
    };

    if (errorMessage) {
      return (
        <div className="error-loading">
          <p>this.props.kloudless.errorMessage</p>
        </div>
      );
    }

    if (isLoading) return <ProgressBar now={100} active />;

    return (
      <div className="kloudless-layout">
        <PricingAgreement dispatch={this.props.dispatch}
                          showAgreeLink={!agreedToPricing} />

        <div>
          <Notification/>
          <div className="kloudless-switch-container">
            <BoxSwitch          { ... svcProps( 'box'      )} />
            <DropboxSwitch      { ... svcProps( 'dropbox'  )} />
            <GoogleDriveSwitch  { ... svcProps( 'gdrive'   )} />
            { drupalPermsInclude( 'iManage Integration') &&
              <IManageSwitch      { ... svcProps( 'imanage'  )} />}
            <OneDriveSwitch     { ... svcProps( 'onedrive' )} />
            <SharepointSwitch   { ... svcProps( 'sharepoint' )} />

            { drupalPermsInclude('NetDocuments Integration') &&
              <NetDocumentsSwitch { ... svcProps( 'netdocuments' )} />}

            { drupalPermsInclude('Clio Integration') &&
              <ClioSwitch         { ... svcProps( 'clio' )} />}
            { drupalPermsInclude('RocketMatter Integration') &&
              <RocketMatterSwitch   { ... svcProps( 'rocketmatter' ) } />
            }
            <CalendarFeedSwitch   { ... svcProps( 'calendar' )} />
          </div>
          <InstructionsPanel />
        </div>

        {connections.length > 0 &&
          <h1 className="title">Service Settings</h1>
        }
        <Tabs animation={false}>
        {connections.map( (connection, index) => (
          <Tab eventKey={index} title={<span><i className="fa fa-gear"/> {connection.service}</span>}>
            {connection.connectionId && agreedToPricing && connection.integration_type === 'files' && !connection.hasMatterFolders &&
              <FileSyncUploadDestinationSettings
                dispatch={this.props.dispatch}
                connectionId={connection.connectionId}
                folderConfig={connection.folder_config}
              />
            }

            {connection.connectionId && agreedToPricing && connection.integration_type === 'files' &&
              <FileSyncSettings
                dispatch={this.props.dispatch}
                connectionId={connection.connectionId}
                syncType={connection.sync_type}
                syncFrom={connection.sync_from}
                combinePDFs={connection.combine_pdfs}
                syncMode={connection.sync_mode}
              />
            }

            {connection.connectionId && agreedToPricing && connection.integration_type === 'calendar' &&
              <CalendarFeedConfig
                connectionId={connection.connectionId}
                dispatch={this.props.dispatch}
              />}

            {connection.connectionId && agreedToPricing && connection.integration_type === 'files' && connection.filenameSettings &&
              <FilenameTemplate
                filenameTemplate={connection.filenameSettings.filenameTemplate}
                connectionId={connection.connectionId}
                dispatch={this.props.dispatch}
                allowFolderConfiguration={connection.folder_config === 'connection'}
                hasAppFolder={connection.hasAppFolder}
              />}

            {connection.connectionId && agreedToPricing && connection.service === 'netdocuments' &&
              <NetDocumentsDocketLinkPanel connectionId={connection.connectionId} />
            }

            {connection.connectionId && agreedToPricing && connection.service === 'netdocuments' &&
              <NetDocumentsCabinetsConfig
                connectionId={connection.connectionId}
                dispatch={this.props.dispatch}
              />}

            {connection.connectionId && agreedToPricing && connection.service === 'clio' &&
              <ClioConnectionSettings
                connectionId={connection.connectionId}
                dispatch={this.props.dispatch}
              />}

            {connection.connectionId && agreedToPricing && connection.service === 'sharepoint' && connection.folder_config === 'connection' &&
              <SharepointConnectionSettings
                connectionId={connection.connectionId}
                dispatch={this.props.dispatch}
              />
            }
          </Tab>
        ))}
        </Tabs>

      </div>
    );
  }
}

ConnectionsLayout.propTypes = {
  dispatch: PropTypes.func.isRequired,
  kloudless: PropTypes.object.isRequired,
  svc: PropTypes.array.isRequired,
};


function mapStateToProps(state) {
  return {
    kloudless: state.get('kloudless'),
  };
}

export default connect(mapStateToProps)(ConnectionsLayout);


// WEBPACK FOOTER //
// ./src/Integrations/connections/ConnectionsLayout.jsx